module.exports = __webpack_public_path__ + "img/re.85556bea.svg";